<template lang="pug">
  v-card(color="deep-purple darken-1" dark hover)
    v-card-text(style="height: 128px;")
      v-layout(align-center justify-center column fill-height)
        v-progress-circular(v-if="isLoading" size="70" width="7" color="white" indeterminate)
        animated-number.display-1.font-weight-light(v-if="!isLoading" :value="openLeads" :formatValue="formatToNumber" :duration="1000")
        div.text-xs-center.body-1 {{ $t('labels.openLeads') }}
</template>

<script>
import dashbaordService from '../../service.js'
import AnimatedNumber from "animated-number-vue";

export default {
  data() {
    return {
      openLeads: 0,
      isLoading: true
    }
  },
  components: {
    AnimatedNumber
  },
  mounted() {
    this.getOpenLeads()
  },
  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getOpenLeads() {
      dashbaordService.getOpenLeads()
      .then(result => {
        this.openLeads = result.data
        this.isLoading = false
      })
    },
  }
}
</script>

<style scoped>
</style>